export default __webpack_public_path__ + "media/theresaVid.98a573b6.mp4";